"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestTitle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Text_1 = __importDefault(require("@atg/icf-react-components/components/Text"));
var react_jss_1 = require("react-jss");
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    contestTitle: {
        marginBottom: "16px",
        hyphens: "auto",
        wordBreak: "break-word",
    },
}); });
var ContestTitle = function (_a) {
    var props = __rest(_a, []);
    var classes = useStyles();
    return ((0, jsx_runtime_1.jsx)(Text_1.default, { variant: "heading_l", className: classes.contestTitle, children: props.children }));
};
exports.ContestTitle = ContestTitle;
//# sourceMappingURL=ContestTitle.js.map